module.exports = __webpack_public_path__ + "static/media/clipboard-list-flat.d1d85938.svg";